module.exports = __webpack_public_path__ + "img/filter-type-core.8acf398d.svg";